<template>
  <div class="translationSettingsDialog">
    <el-dialog :close-on-click-modal="false" :show-close="false" custom-class="translationSettings"
               :visible.sync="translateVisible" :before-close="handlerClose">
      <template slot="title">
        <DialogsHeader :title="$t('intelligentTranslation.TranslationSetting')" />
      </template>
      <div class="content">
        <div class="content-item">
          <p>{{$t('newProjectV2.transMemoryBank')}}</p>
          <el-button @click="handlerTranslation('memory')" type="primary" size="small">
            {{$t('projectV2.setUp')}}</el-button>
          <el-switch v-model="switchone" active-color="#13ce66" inactive-color="#E6E6E6">
          </el-switch>
        </div>
        <div class="content-item">
          <p>{{$t('term.termLib')}}</p>
          <el-button @click="handlerTranslation('term')" type="primary" size="small">
            {{$t('projectV2.setUp')}}</el-button>
          <el-switch v-model="switchtow" active-color="#13ce66" inactive-color="#E6E6E6">
          </el-switch>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handlerClose">{{$t('termBankV2.cancel')}}</el-button>
        <el-button type="primary" @click="handlerdetermine">
          {{$t('termBankV2.confirm')}}</el-button>
      </div>
    </el-dialog>
    <translationCorpus-dialog :dialogType="dialogType" ref="childone"
                              :translationCorpusVisible="translationCorpusVisible"
                              @handlerClose="closetranslationCorpus"
                              @handlerdetermine="determinetranslationCorpus">
    </translationCorpus-dialog>
  </div>
</template>
<script>
// 标题组件
import DialogsHeader from '@/common/dialogsHeader';
import translationCorpusDialog from "./translationCorpusDialog";
export default {
  name: "translationSettingsDialog",
  props: {
    translateVisible: {
      type: Boolean,
      default: false
    },
    langInfo: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      switchone: false,
      switchtow: false,
      translationCorpusVisible: false,
      dialogType: "",
      mountInfo: []
    }
  },

  components: { DialogsHeader, translationCorpusDialog },
  methods: {
    handlerClose() {
      this.$emit('handlerClose')
    },
    handlerdetermine() {
      let dataInfo = {
        switchone: this.switchone,
        switchtow: this.switchtow
      }
      this.$emit('handlerdetermine', dataInfo)
    },
    //语料库设置
    async handlerTranslation(type) {
      this.dialogType = type;
      this.$emit('handlerClose')
      this.translationCorpusVisible = true;
      this.$nextTick(() => {
        this.$refs['childone'].getSelectableTermMemoryList(this.langInfo, type, this.mountInfo);
      })
    },
    determinetranslationCorpus(mountInfo) {
      this.mountInfo = mountInfo;
      this.$emit('determinetranslationCorpus', mountInfo)
      this.translationCorpusVisible = false;
    },
    closetranslationCorpus() {
      this.$emit('determinetranslationCorpus', this.mountInfo)
      this.translationCorpusVisible = false;
    }
  }
}
</script>
<style lang="less" scoped>
.translationSettingsDialog {
  /deep/.translationSettings {
    width: 416px;
    height: 262px;
    border-radius: 4px 4px 4px 4px;
    box-shadow: 0px 10px 28px 1px rgba(51, 51, 51, 0.18);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0px;
    margin-top: 0px !important;
    .el-dialog__header {
      padding: 16px 32px 0px 32px;
    }
    .el-dialog__body {
      padding: 14px 32px 30px 32px;
      .content-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
          min-width: 140px;
          text-align: left;
        }
        .el-button {
          padding: 7px 24px;
        }
        &:last-child {
          margin-top: 7px;
        }
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      .el-button {
        padding: 7px 24px;
        height: 32px;
      }
      .el-button + .el-button {
        margin-left: 20px;
      }
      .el-button--default {
        border-color: #0078fc;
        color: #0078fc;
      }
    }
  }
}
</style>